export default {
    SET_REQUEST(state, response){
        state.requests_count = response;
    }
}